import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import TextArea from "components/TextArea";

import { ReactComponent as ChevronIcon } from 'icons/components/chevron.svg';

import './themes/default.less';
import './index.less';

export default class AreaExpande extends MainComponent {
    static propTypes = {
        text: PropTypes.string,
        content: PropTypes.string,
        onChange: PropTypes.func,
        onClick: PropTypes.func,
        onKeyDown: PropTypes.func,
    };
    static defaultProps = {
        text: "",
        content: "",
        onChange: null,
        onClick: null,
        onKeyDown: null,
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            expande: false,
            tooltip: false,
        };
    }

    set expande(value) {
        this.changeState("expande", value);
        this.textAr.value = this.props.content;
    }

    set content(value) {
        this.textAr.value = value;
    }

    get content() {
        return this.textAr.value;
    }

    onToggle() {
        this.toggleState("expande");
        this.textAr.value = this.props.content;
    }

    render() {

        const { text, content, onChange, onClick, onKeyDown } = this.props;
        const { expande/*, tooltip*/ } = this.state;
        const cl = expande ? "" : "rotate180";

        return (
            <div className="areaExpande flex col gap8">
                <div
                    className="areaInputTitle text p1 flex gap8 centerV hand"
                    onClick={this.onToggle.bind(this)}>
                    <ChevronIcon className={cl} />
                    {this.tr(text)}
                </div>
                <div className={`areaInput ${expande ? "" : "hide"}`} >
                    <TextArea
                        ref={el => this.textAr = el}
                        onFocus={this.changeState.bind(this, "tooltip", true)}
                        onBlur={this.changeState.bind(this, "tooltip", false)}
                        placeHolder="client.fieldNotFilled"
                        onKeyDown={onKeyDown}
                        onClick={onClick}
                        onChange={onChange} />
                </div>
                <div className={`areaInputCont text p1 ${expande ? "hide" : ""}`}>
                    {content}
                </div>
                {/*tooltip ? <div className="areaInputCom text p2">{this.tr("client.useTab")}</div> : <div></div>*/}
            </div>
        );
    }
}
